<template>
  <div class="container pt-100">
    <div class="row">
      <div class="col-xxl-10 offset-xxl-1">
        <div class="single-img round-6 mb-50">
          <img
            src="../../assets/img/portfolio/single-portfolio-1.webp"
            alt="Image"
            class="round-6"
          />
        </div>
        <div class="row">
          <div class="col-xl-8 pe-xxl-5">
            <div class="portfolio-desc">
              <div class="single-para">
                <h2>Mockup & Branding Design</h2>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen.
                </p>
              </div>
              <div class="single-para">
                <h4>The Challenge</h4>
                <p>
                  Go after leads more effectively, find out the status other
                  sales cycle, and optimize efforts. Automate most process with
                  powerful tools for maximum for this is a text in this.
                </p>
                <ul class="feature-list list-style">
                  <li class="text-title position-relative">
                    NYmag only uses the most trending layouts and mockups for
                    its eye caching
                  </li>
                  <li class="text-title position-relative">
                    Product marketing to targeted customers for business support
                    system needed
                  </li>
                  <li class="text-title position-relative">
                    Downloadable lectures, code and design assets for all
                    projects
                  </li>
                </ul>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen.
                </p>
              </div>
              <div class="single-para">
                <h4>Business Solution</h4>
                <p>
                  Go after leads more effectively, find out the status other
                  sales cycle, and optimize efforts. Automate most process with
                  powerful tools for maximum for this is a text.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  book.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-4">
            <SidebarWidget />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SidebarWidget from "./SidebarWidget.vue";

export default defineComponent({
  name: "PortfolioDetails",
  components: {
    SidebarWidget,
  },
});
</script>